export * from './faq-section'
export * from './footer'
export * from './heading'
export * from './product-details'
